// The Warranty menu group, in order. Each item is shown when the user holds its permission; the
// first one a user may see is where the group's own link goes. `segments` are the first path
// segments of the item's screens, so the menu keeps the right item lit on a detail screen.
import {
  WARRANTY_HEALTH_URL,
  WARRANTY_EXCEPTIONS_URL,
  WARRANTY_REFUNDS_URL,
  WARRANTY_PARTNER_POLICIES_URL,
  WARRANTY_PARTNER_SETTLEMENT_URL,
  WARRANTY_PLANS_URL,
  WARRANTY_PLAN_DRAFT_URL,
  WARRANTY_PLAN_HISTORY_URL,
  WARRANTY_SUBSCRIPTIONS_URL,
  WARRANTY_SUBSCRIPTION_URL,
  WARRANTY_AWAITING_INVOICE_URL,
  WARRANTY_REVIEW_QUEUE_URL,
  WARRANTY_CATALOGUE_IMAGES_URL,
  WARRANTY_ALL_URL,
  WARRANTY_JOURNEY_URL,
  WARRANTY_VENDOR_POLICIES_URL,
  WARRANTY_CHAT_ORDERS_URL,
  WARRANTY_CHAT_ORDER_URL,
} from "../../Shared/constant";
import { WARRANTY_PERMISSION, hasOneOfWarrantyPermissions, hasWarrantyPermission } from "./warrantyAccess";

const segment = (url) => url.slice(1);

export const WARRANTY_NAV = [
  {
    key: "health",
    label: "Health",
    permission: WARRANTY_PERMISSION.OPS,
    url: WARRANTY_HEALTH_URL,
    segments: [segment(WARRANTY_HEALTH_URL), segment(WARRANTY_EXCEPTIONS_URL)],
  },
  {
    key: "all-warranties",
    label: "All warranties",
    permission: [WARRANTY_PERMISSION.REVIEW, WARRANTY_PERMISSION.VIEW],
    url: WARRANTY_ALL_URL,
    segments: [segment(WARRANTY_ALL_URL), segment(WARRANTY_JOURNEY_URL)],
  },
  {
    key: "plans",
    label: "Assure plans",
    permission: WARRANTY_PERMISSION.PLANS_ADMIN,
    url: WARRANTY_PLANS_URL,
    segments: [
      segment(WARRANTY_PLANS_URL),
      segment(WARRANTY_PLAN_DRAFT_URL),
      segment(WARRANTY_PLAN_HISTORY_URL),
    ],
  },
  {
    key: "subscriptions",
    label: "Assure customers",
    permission: [WARRANTY_PERMISSION.OPS, WARRANTY_PERMISSION.VIEW],
    url: WARRANTY_SUBSCRIPTIONS_URL,
    segments: [segment(WARRANTY_SUBSCRIPTIONS_URL), segment(WARRANTY_SUBSCRIPTION_URL)],
  },
  {
    // 2 Nov 2026 (Sachin): read only, the same permissions as Assure customers.
    key: "chat-orders",
    label: "Chat orders",
    permission: [WARRANTY_PERMISSION.OPS, WARRANTY_PERMISSION.VIEW],
    url: WARRANTY_CHAT_ORDERS_URL,
    segments: [segment(WARRANTY_CHAT_ORDERS_URL), segment(WARRANTY_CHAT_ORDER_URL)],
  },
  {
    key: "awaiting-invoice",
    label: "Awaiting invoice",
    permission: WARRANTY_PERMISSION.OPS,
    url: WARRANTY_AWAITING_INVOICE_URL,
    segments: [segment(WARRANTY_AWAITING_INVOICE_URL)],
  },
  {
    key: "theft-roadside",
    label: "Theft & roadside to buy",
    permission: WARRANTY_PERMISSION.OPS,
    url: WARRANTY_VENDOR_POLICIES_URL,
    segments: [segment(WARRANTY_VENDOR_POLICIES_URL)],
  },
  {
    key: "partner-policies",
    label: "Partner policies",
    permission: WARRANTY_PERMISSION.OPS,
    url: WARRANTY_PARTNER_POLICIES_URL,
    segments: [segment(WARRANTY_PARTNER_POLICIES_URL)],
  },
  {
    key: "partner-settlement",
    label: "Partner settlement",
    permission: WARRANTY_PERMISSION.OPS,
    url: WARRANTY_PARTNER_SETTLEMENT_URL,
    segments: [segment(WARRANTY_PARTNER_SETTLEMENT_URL)],
  },
  {
    key: "refunds",
    label: "Refunds",
    permission: WARRANTY_PERMISSION.OPS,
    url: WARRANTY_REFUNDS_URL,
    segments: [segment(WARRANTY_REFUNDS_URL)],
  },
  {
    key: "review-queue",
    label: "Review queue",
    permission: WARRANTY_PERMISSION.REVIEW,
    url: WARRANTY_REVIEW_QUEUE_URL,
    segments: [segment(WARRANTY_REVIEW_QUEUE_URL)],
  },
  {
    key: "catalogue-images",
    label: "Catalogue images",
    permission: WARRANTY_PERMISSION.PLANS_ADMIN,
    url: WARRANTY_CATALOGUE_IMAGES_URL,
    segments: [segment(WARRANTY_CATALOGUE_IMAGES_URL)],
  },
];

export const visibleWarrantyNav = (selfInfo) =>
  WARRANTY_NAV.filter((item) =>
    Array.isArray(item.permission)
      ? hasOneOfWarrantyPermissions(selfInfo, item.permission)
      : hasWarrantyPermission(selfInfo, item.permission)
  );

export const firstWarrantyUrl = (selfInfo) => visibleWarrantyNav(selfInfo)[0]?.url || null;

export const isWarrantySegment = (firstSegment) =>
  WARRANTY_NAV.some((item) => item.segments.includes(firstSegment));
